export default "__VITE_ASSET__knU2fLiT__"